import React from 'react';
export function Bonuses() {
  const bonuses = [{
    title: 'BANCO DE 100 PROBLEMAS TÉCNICOS RESUELTOS',
    desc: 'Problemas de cálculo aplicado: sección de conductores, caída de tensión y potencia instalada.',
    value: '$15 USD'
  }, {
    title: 'KIT DE SIMBOLOGÍA ELÉCTRICA INTERNACIONAL',
    desc: 'Láminas con los 80 símbolos normalizados más utilizados en planos eléctricos.',
    value: '$10 USD'
  }, {
    title: 'GUÍA DEL EGRESADO ELECTRICISTA',
    desc: 'Cómo presupuestar un trabajo de instalación eléctrica profesional hoy mismo.',
    value: '$12 USD'
  }, {
    title: 'RÚBRICAS DE EVALUACIÓN DE TALLER',
    desc: 'Herramientas para evaluar el desempeño práctico. Termina con el "profe, ¿por qué tengo esta nota?".',
    value: '$8 USD'
  }];
  return <section className="py-10 px-4 bg-brand-dark border-y border-white/5" data-id="element-17">
      <div className="max-w-xl mx-auto" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-xl md:text-2xl font-black text-brand-accent mb-2" data-id="element-20">
            🎁 4 BONOS ESTRATÉGICOS (INCLUIDOS GRATIS)
          </h2>
          <p className="text-sm text-gray-300" data-id="element-21">
            Recursos que completan tu arsenal docente:
          </p>
        </div>

        <div className="flex flex-col gap-4" data-id="element-22">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-md p-4 border border-white/5" data-id="element-23">
              <h3 className="text-sm font-bold text-white mb-2" data-id="element-24">
                {bonus.title}
              </h3>
              <p className="text-sm text-gray-400 mb-2" data-id="element-25">{bonus.desc}</p>
              <p className="text-xs font-bold text-brand-accent" data-id="element-26">
                (Valor: {bonus.value}) — GRATIS.
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}